import { MOBILE_LAYOUT_BREAKPOINT } from "helpers/breakpoints";
import { useWindowSize } from "react-use-size";

export default function useMobileLayout() {
  const windowSize = useWindowSize();
  return windowSize.width <= MOBILE_LAYOUT_BREAKPOINT;
}
